import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AnalyticsReferralsActions} from 'src/action-creators/analytics/analytics-referrals';
import type {
  SavedDashboardList,
  CurrentReferralFilters,
  SelectedReferralsFilterColumnsData,
} from 'src/types/analytics-genesis';

import {
  SET_SELECTED_DATE_RANGE,
  RECEIVE_SAVED_DASHBOARDS,
  SET_CURRENT_DASHBOARD_ID,
  SET_SELECTED_REFERRALS_FILTERS,
  CLEAR_SELECTED_FILTERS,
  RECEIVE_REFERRALS_OVERVIEW_TABLE_COLUMNS,
  RECEIVE_PROGRAMS_OVERVIEW_TABLE_COLUMNS,
  RECEIVE_JOBS_OVERVIEW_TABLE_COLUMNS,
  RECEIVE_PAYOUTS_OVERVIEW_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-referrals';


export type AnalyticsReferralsState = {
  selectedDateRange: DateRangeWithTimezone;
  savedDashboards: SavedDashboardList;
  currentDashboardID: string | null | undefined;
  selectedReferralFilters: CurrentReferralFilters;
  referralsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
  programsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
  jobsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
  payoutsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
};

const initialState: AnalyticsReferralsState = {
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  savedDashboards: [],
  currentDashboardID: null,
  selectedReferralFilters: {
    job: [],
    program_name: [],
    source: [],
    team_member: [],
  },
  referralsOverviewTableColumnFilter: null,
  programsOverviewTableColumnFilter: null,
  jobsOverviewTableColumnFilter: null,
  payoutsOverviewTableColumnFilter: null,
};

export default (
  state: AnalyticsReferralsState = initialState,
  action: AnalyticsReferralsActions,
): AnalyticsReferralsState => {
  switch (action.type) {
    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      return {
        ...state,
        savedDashboards: action.payload,
      };
    }
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case SET_SELECTED_REFERRALS_FILTERS: {
      const {selectedReferralFilters} = state;
      return {
        ...state,
        selectedReferralFilters: {
          ...selectedReferralFilters,
          ...action.payload,
        },
      };
    }
    case CLEAR_SELECTED_FILTERS: {
      return {
        ...state,
        selectedReferralFilters: {
          job: [],
          program_name: [],
          source: [],
          team_member: [],
        },
      };
    }
    case RECEIVE_REFERRALS_OVERVIEW_TABLE_COLUMNS: {
      return {...state, referralsOverviewTableColumnFilter: action.payload};
    }

    case RECEIVE_PROGRAMS_OVERVIEW_TABLE_COLUMNS: {
      return {...state, programsOverviewTableColumnFilter: action.payload};
    }
    case RECEIVE_JOBS_OVERVIEW_TABLE_COLUMNS: {
      return {...state, jobsOverviewTableColumnFilter: action.payload};
    }
    case RECEIVE_PAYOUTS_OVERVIEW_TABLE_COLUMNS: {
      return {...state, payoutsOverviewTableColumnFilter: action.payload};
    }
  }
  return state;
};
